import { createSlice } from "@reduxjs/toolkit";

const initialState={
    filteredValue:"",
    filteredPlanValue:""
}

const couponListFilterReducer = createSlice({
    name:"couponListFilterReducer",
    initialState,
    reducers:{
        addFilteredValue(state,action){
            state.filteredValue = action.payload
        },
        addFilteredPlanValue(state,action){
            state.filteredPlanValue = action.payload
        },
        removeFilteredCouponValue(state,action){
            state.filteredValue = action.payload
            state.filteredPlanValue=action.payload

        }
       
    }
})

export const {addFilteredValue,addFilteredPlanValue,removeFilteredCouponValue} = couponListFilterReducer.actions;
export default couponListFilterReducer.reducer;